import { useEffect, useState } from "react";

export default function ThemeToggle() {
  const [theme, setTheme] = useState(() => {
    // 初回ロード時にlocalStorageから取得
    return localStorage.getItem("theme") || "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <div
      onClick={toggleTheme}
      aria-pressed={theme === "dark"}
      className="theme-button"
    >
      {/* {theme === "dark" ? "Dark" : "Light"} */}
    </div>
  );
}
